import { domClasses } from '../../player/dom';
import { TEXT_TRACK_DEFAULT, TEXT_TRACK_MIDDLE, TEXT_TRACK_MINI_PLAYER } from '../../common/constants';

const DEFAULT_TIME_VALUE = '00:00';

function leftpad(number) {
  return number > 9 ? number.toString() : `0${number}`;
}

export const formatTime = (timestampS) => {
  if (timestampS === null || timestampS === undefined) {
    return DEFAULT_TIME_VALUE;
  }

  const date = new Date(timestampS * 1000);

  return `${leftpad(date.getHours())}:${leftpad(date.getMinutes())}:${leftpad(date.getSeconds())}`;
};

export const formatHhMmSs = (duration) => {
  if (duration === null || duration === undefined) {
    return DEFAULT_TIME_VALUE;
  }

  const durationInSeconds = Math.abs(Math.round(duration));
  const ss = durationInSeconds % 60;
  const mm = Math.floor(durationInSeconds / 60) % 60;
  const hh = Math.floor((durationInSeconds / 60) / 60);

  if (hh > 0) {
    return `${duration < 0 ? '-' : ''}${leftpad(hh)}:${leftpad(mm)}:${leftpad(ss)}`;
  }

  return `${duration < 0 ? '-' : ''}${leftpad(mm)}:${leftpad(ss)}`;
};

export const formatHhMmSsShort = (duration) => {
  // possible time returned 0, 5, 2:04, 1:03:03
  if (duration === null || duration === undefined) {
    return 0;
  }

  const durationInSeconds = Math.abs(Math.round(duration));
  const ss = durationInSeconds % 60;
  const mm = Math.floor(durationInSeconds / 60) % 60;
  const hh = Math.floor((durationInSeconds / 60) / 60);

  if (hh > 0) {
    return `${duration < 0 ? '-' : ''}${hh}:${leftpad(mm)}:${leftpad(ss)}`;
  }

  if (mm > 0) {
    return `${duration < 0 ? '-' : ''}${mm}:${leftpad(ss)}`;
  }

  return `${duration < 0 ? '-' : ''}${ss}`;
};

export const formatHHMM = (timestampS) => {
  if (timestampS === null || timestampS === undefined) {
    return DEFAULT_TIME_VALUE;
  }

  const date = new Date(timestampS * 1000);

  return date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
};

export const CHROMECAST_STATES = {
  CONNECTED: 'connected',
  CONNECTING: 'connecting',
  UNAVAILABLE: 'unavailable',
  DISCONNECTED: 'disconnected',
};

const isType = t => elem => Object.prototype.toString.call(elem).slice(8, -1) === t;

export const isFunction = isType('Function');

export const moveSubtitles = (moveToTop, mini = false, player) => {
  const subtitles = player.subtitlesElement;
  if (!subtitles) return;
  if (mini) {
    subtitles.classList.remove(domClasses.withControls);
    player.changeTextTrackPosition(TEXT_TRACK_MINI_PLAYER);
  } else if (moveToTop) {
    subtitles.classList.add(domClasses.withControls);
    player.changeTextTrackPosition(TEXT_TRACK_MIDDLE);
  } else {
    subtitles.classList.remove(domClasses.withControls);
    player.changeTextTrackPosition(TEXT_TRACK_DEFAULT);
  }
};

export const getRating = (viewable) => {
  if (!viewable) return null;
  if (viewable.contentRating) return viewable.contentRating;
  if (viewable.rating) return { name: viewable.rating };
  return null;
};
